import {
  TasksStreaksClient,
  StreakStatus,
  StreakConfigList,
  NextStreakMilestone,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const streaksClient = new TasksStreaksClient(
  apiConfig,
  undefined,
  axiosInstance
);

const handleGetStreakStatus = async (): Promise<StreakStatus | undefined> => {
  try {
    return (await streaksClient.getMyStreakStatus()).data;
  } catch {
    return;
  }
};

const handleGetAvailableStreaks = async (): Promise<
  StreakConfigList | undefined
> => {
  try {
    return (await streaksClient.getAvailableStreaks()).data;
  } catch {
    return;
  }
};

const handleGetNextStreakMilestone = async (): Promise<
  NextStreakMilestone | undefined
> => {
  try {
    return (await streaksClient.getMyNextStreakMilestone()).data;
  } catch {
    return;
  }
};

export {
  handleGetStreakStatus,
  handleGetAvailableStreaks,
  handleGetNextStreakMilestone,
};
